import { cn } from "@/lib/utils";
import { MyelinaMark } from "@/components/brand/MyelinaMark";

interface PageLoaderProps {
  className?: string;
  label?: string;
}

/**
 * Consistent full-page loading state used inside Suspense fallbacks.
 * Remains visible for as long as the parent renders it, so callers are
 * responsible for unmounting it once data is ready.
 * Respects reduced-motion by removing the pulse when the user prefers
 * reduced motion.
 */
export function PageLoader({ className, label = "Loading" }: PageLoaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center min-h-[50vh] gap-4",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="relative">
        <div className="absolute inset-0 -m-6 rounded-full bg-primary/5 blur-2xl motion-safe:animate-pulse" aria-hidden="true" />
        <div className="relative w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center">
          <MyelinaMark className="h-6 w-6 text-primary" />
        </div>
      </div>
      <p className="text-sm font-medium text-muted-foreground">{label}</p>
    </div>
  );
}

export default PageLoader;

